import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestGuides() {
  const displayArticles = articles.slice(0, 6);

  return (
    <section id="guides" className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 px-3 py-1 rounded-full mb-4">
              Latest Resources
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Latest Basetao Guides &amp; Articles
            </h2>
          </div>
          <Link
            to="/article/basetao-review"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Articles
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="h-44 bg-background-100 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-xs font-medium text-primary-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {articles.length > 6 && (
          <div className="text-center mt-8">
            <Link
              to="/article/basetao-review"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-300/60 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              View All {articles.length} Articles
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}